<template>
  <div id="app">
    <router-view :settings="settings">
      <template v-slot:detailinfo><slot name="detailinfo"></slot></template>
      <template v-slot:detailcontact><slot name="detailcontact"></slot></template>
      </router-view>
    <div class="version">Versie: {{ $store.getters.appVersion }}</div>
  </div>
</template>

<script>

  export default {
    props: ['settings'],
  };
  </script>

<style scoped>
.version {
  text-align: right;
  font-size: 8px;
}
</style>
